import { motion } from 'framer-motion';
import Feature from './Feature';
import { staggerContainer } from '../utils/animations';

const Features = () => {
  const features = [
    {
      title: 'Unique Miniatures',
      description: 'Exclusively sculpted in-house by Dungeon Labs artists, with 8 unique miniatures per pack.',
    },
    {
      title: 'Curated Paints',
      description: 'High-quality Dungeon Labs acrylic paints, specifically chosen to suit the miniatures in your pack.',
    },
    {
      title: 'Quality Brushes',
      description: 'Dungeon Labs brushes designed for essential techniques including base coating and detail work.',
    },
    {
      title: 'Professional Packaging',
      description: 'Custom-cut foam inserts securing all miniatures, paints, and brushes during transport.',
    },
    {
      title: 'Step-by-Step Guides',
      description: 'Detailed painting guides to help beginners and challenge experienced painters.',
    },
    {
      title: 'Adventure Modules',
      description: 'Short tabletop RPG adventures designed to utilize all the painted miniatures from the pack.',
    },
  ];

  return (
    <section id="features" className="py-24 bg-slate-900">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-2 text-white mb-4">Complete Painting Experience</h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Everything you need to bring fantasy creatures and characters to life, all in one premium package.
          </p>
        </div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={staggerContainer()}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.25 }}
        >
          {features.map((feature, index) => (
            <Feature 
              key={index} 
              title={feature.title} 
              description={feature.description} 
            />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
